import { useCallback, useState } from "react";
import { getWorkspaces } from "../api";
import { useToast } from "./use-toast";
import { useAuth } from "../contexts/AuthContext";

export const useWorkspaces = (defaultWorkspace = "") => {
  const [workspaces, setWorkspaces] = useState([]);
  const [selectedWorkspace, setSelectedWorkspace] = useState(
    defaultWorkspace || ""
  );
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { toast } = useToast();
  const { logout } = useAuth();

  const fetchWorkspaces = useCallback(async () => {
    try {
      setIsLoading(true);
      const workspacesData = await getWorkspaces();
      setWorkspaces(workspacesData);

      // Set default workspace if provided or use first from list
      const workspaceToUse =
        defaultWorkspace ||
        process.env.REACT_APP_DEFAULT_WORKSPACE ||
        (workspacesData.length > 0 ? workspacesData[0].slug : "");

      if (workspaceToUse) {
        setSelectedWorkspace(workspaceToUse);
      }

      setIsLoading(false);
      return workspacesData;
    } catch (err) {
      setError("Failed to load workspaces");
      setIsLoading(false);

      if (err.response && err.response.status === 401) {
        logout();
      }

      toast({
        title: "Error",
        description: "Failed to load workspaces",
        variant: "destructive",
      });

      throw err;
    }
  }, [defaultWorkspace, logout, toast]);

  return {
    workspaces,
    selectedWorkspace,
    setSelectedWorkspace,
    isLoading,
    error,
    fetchWorkspaces,
  };
};
